module.exports = __webpack_public_path__ + "static/img/Clare-Hunt.07d1b72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Clare-Hunt.jpg
// module id = ywAI
// module chunks = 0